<template>
  <div>
    <!-- AS A DROPDOWN -->
    <el-dropdown v-if="asDropDown" trigger="click" @command="handleSetLanguage">
      <div class="flags mr-2" style="cursor: pointer">
        <img v-if="language === 'gr'" src="@/assets/images/gr.svg" alt="flag" />
        <img
          v-else-if="language === 'en'"
          src="@/assets/images/en.svg"
          alt="flag"
        />
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="en" :disabled="language === 'en'">
          <img src="@/assets/images/en.svg" class="round flagIcon" alt="flag" />
          English
        </el-dropdown-item>
        <el-dropdown-item command="gr" :disabled="language === 'gr'">
          <img src="@/assets/images/gr.svg" class="round flagIcon" alt="flag" />
          Ελληνικά
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- AS A LIST OF FLAGS -->

    <ul v-else class="list-of-languages">
      <li class="mr-2" @click="handleSetLanguage('gr')">
        <img class="lang-flag" src="@/assets/images/gr.svg" alt="Greek flag" />
      </li>
      <li class="mr-2" @click="handleSetLanguage('en')">
        <img
          class="lang-flag"
          src="@/assets/images/en.svg"
          alt="English flag"
        />
      </li>
    </ul>
  </div>
</template>

<script>
// import store from '@/store';
export default {
  name: 'LangSelector',
  props: {
    asDropDown: { type: Boolean, required: false, default: false }
  },
  computed: {
    language() {
      return this.$store.getters.getMyLang;
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch('setLanguage', lang);
      this.$store.dispatch('data/getMenus');
    }
  }
};
</script>

<style scoped>
.flags {
  height: 30px;
  width: 30px;
}

.flagIcon {
  width: 20px;
  height: 20px;
  position: relative;
  top: 5px;
  right: 5px;
}

.list-of-languages {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: center;
  margin: 0;
}

.lang-flag {
  height: 30px;
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/LangSelector/index.vue